<template>
  <div style="text-align: left; margin-left: 20px;">

        <el-checkbox v-model="$store.state.inventoryMaster.props.estore_price_variation_available">
            Is Price Variations Available?
        </el-checkbox>
        <div v-if="$store.state.inventoryMaster.props.estore_price_variation_available" style="display: flex; flex-direction: column;">
            
            <div 
                v-for="(data, index) in $store.state.inventoryMaster.props.estore_price_variation"
                :key="index"
                style="display: flex; flex-direction: column;  margin-bottom: 30px; border-bottom: 1px solid #000000;">

                    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                        
                        <div style="display: flex; flex-direction: row;">
                            <div style="margin-top: 10px;">
                                <span type="label">Price Heading</span>
                                <br>
                                <el-input @focus="$event.target.select()"
                                    size="small"
                                    v-model="data.variation_title">
                                </el-input>
                            </div>

                            <div style="margin-top: 10px; margin-left: 20px;">
                                <span type="label">Price (Incl. Taxes)</span>
                                <br>
                                <div style="display: flex; flex-direction: row;">
                                    <el-checkbox v-model="data.coming_soon" style="top: 10px; position: relative; margin-right: 5px">
                                        Coming Soon?
                                    </el-checkbox>
                                    <el-select 
                                        v-if="!data.coming_soon"
                                        default-first-option
                                        size="small"
                                        v-model="data.price_currency_id" filterable style="text-align: left;">
                                        <el-option
                                            v-for="(data, index) in $store.getters.getCountryList"
                                            :key="index"
                                            :label="data.currency_short"
                                            :value="data.id">
                                            <span style="float: left" v-html="data.currency_short"></span>
                                            <span style="float: right;">{{ data.country_name }}</span>
                                        </el-option>
                                    </el-select>
                                    <el-input 
                                        v-if="!data.coming_soon"
                                        @focus="$event.target.select()"
                                        size="small"
                                        type="number"
                                        style="margin-left: 10px; width: 250px;"
                                        v-model="data.price">
                                    </el-input>  
                                </div>
                                                             
                                
                            </div>
                           <!-- <el-checkbox style="left: 10px; top: 35px; position: relative;" v-model="data.display_to_self_country">
                                    Display To Visitors From {{getCurrencyFormat.country_name}}
                            </el-checkbox> -->

                        </div>
                        
                        <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addInventoryMasterPriceVariation')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterPriceVariation', data.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div> 

                    </div>
                    

                <el-table
                v-if="!data.coming_soon"
            :data="data.variation_source"
            style="width: 100%; margin-top: 30px;" border>          
            <el-table-column
            prop="source_link"
            label="Source Link">
            <template slot-scope="scope">
                
                <el-checkbox v-model="scope.row.source_self">
                    Purchase In Website
                </el-checkbox>
                <el-input v-if="!scope.row.source_self" @focus="$event.target.select()"
                    size="small"
                    v-model="scope.row.source_link"
                    style="width: 100%;">
                </el-input>
            </template>
            </el-table-column>
            
            <el-table-column
            prop="source_name"
            label="Button Name">
            <template slot-scope="scope">
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="scope.row.source_name"
                    style="width: 100%;">
                </el-input>
            </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a @click="$store.commit('addInventoryMasterPriceVariation_SubList', data.key)" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeInventoryMasterPriceVariation_SubList', {parent_key: data.key, key: scope.row.key})"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>

            </div>

        </div>
        
  </div>
</template>

<script>
export default {
    methods: {
        loadSource($event) {
            let dataId = parseInt($event)
            if(dataId === 9 || dataId === 11 || dataId === 13) {
                if(dataId === 9) {
                    this.loadCategory(0)
                } else if(dataId === 11) {
                    this.loadCategory(2)
                } else if(dataId === 13) {
                    this.loadCategory(1)
                }
            } else if(dataId === 10 || dataId === 12 || dataId === 14) {
                if(dataId === 10) {
                    this.loadItemCategories(0)
                } else if(dataId === 12) {
                    this.loadItemCategories(2)
                } else if(dataId === 14) {
                    this.loadItemCategories(1)
                }
            }
        },
        loadCategory(type) {
            this.$store.dispatch('fetchItemCategoryList', {type: type})
        },
        loadItemCategories(type) {
            this.$store.dispatch('fetchItemSubCategoryList', {type: type})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/EStore/PriceVariation.vue